import { render } from "./createStudyPopup.vue?vue&type=template&id=46837aef&scoped=true"
import script from "./createStudyPopup.js?vue&type=script&lang=js"
export * from "./createStudyPopup.js?vue&type=script&lang=js"

import "./createStudyPopup.vue?vue&type=style&index=0&id=46837aef&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46837aef"]])

export default __exports__